<template>
  <div>
    <h2>{{ $t('views.endusers.changetracking.title') }}</h2>

    <entity-changetracking-table :entityBy="entityBy" :storeModule="storeModule"/>
  </div>
</template>

<script>
import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import MixinEntityBase from '@/components/mixins/EntityBase'
import EntityChangetrackingTable from '@/components/entity/ChangetrackingTable'

export default {
  name: 'EndUsers.ChangeTracking',
  mixins: [MixinEntityBase],
  components: {
    EntityChangetrackingTable
  },
  computed: {
    storeModule () {
      return STOREMODULE_ENDPOINTMODULE_MAP.customer
    },
    entityBy () {
      return {
        name: 'EndUser',
        id: this.eParent.id
      }
    }
  }
}
</script>

<style lang="scss"></style>

